var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"calender",staticClass:"calender-component"},_vm._l((_vm.days),function(day){return _c('div',{staticClass:"day-container",class:{ selected: day.selected, none: day.num > 31 },style:(_vm.size),on:{"click":function($event){return _vm.select(day)}}},[_vm._v("\n    "+_vm._s(day.num)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }